(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('NavController', NavController);

	NavController.$inject = ['$scope', '$state', '$mdSidenav', '$mdUtil', '$log', 'userPouch', '$window', '$mdToast', 'systemPouch', 'WineTable', 'API', 'MessageService', '$mdDialog', '$analytics', 'Utils', 'lodash'];

	function NavController($scope, $state, $mdSidenav, $mdUtil, $log, userPouch, $window, $mdToast, systemPouch, WineTable, API, MessageService, $mdDialog, $analytics, Utils, lodash) {

		/* jshint validthis: true */
		var self = this;

		self.data = {
			selectedIndex : 1
		};

		self.table = WineTable;

		self.$state = $state;

		self.username = undefined;

		self.isExporting = false;

		self.isHome = isHome;
		self.isState = isState;
		self.go = go;
		self.logout = logout;
		self.toggleSidenav = buildToggler('left');
		self.openSidenav = openSidenav;
		self.closeSidenav = closeSidenav;
		self.currentTitle = currentTitle;
		self.print = print;
		self.exportWines = exportWines;
		self.search = search;
		self.changeWineFilter = changeWineFilter;
		self.confirmLogout = confirmLogout;
		self.launchSearch = launchSearch;

		initialize();

        function initialize(){

        	$log.debug('NavController Initialized.');

            userPouch.getActiveUserName().then(function(userName){
                self.username = lodash.capitalize(userName);
            }).catch(function(err){
            	// user might not exist yet, that's ok
				$log.warn('NavController: No active user yet!', err.message);
			});

		}

		function isHome() {
			return $scope.$state.current.name === 'home';
		}

		function isState(state){
			return state === $state.current.name;
		}

		function go(state, params) {

			closeSidenav('left').then(function(){
				$state.transitionTo(state, params);
			});

		}

		function print(){
			closeSidenav('left').then(function(){
                if ($state.current.name === 'wines/edit'){
                    return Utils.go('wines/print/wine', {id: $state.params.id.toString()});
                }
				if ($state.current.name === 'wines'){
					return Utils.go('wines/print');
				}
				return $window.print();
			});
		}

		function changeWineFilter(slug){
			closeSidenav('left').then(function(){
				self.table.setFilterBySlug(slug);
				return true;
			});
		}

		function logout(destroy){

			var remote = userPouch.remote();

			$window.Intercom('shutdown');

			closeSidenav('left');

			WineTable.setWines([]);

            userPouch.cancelReplication()
                .then(function(){
                    if (destroy){
                        return userPouch.destroy();
                    }
                    return true;
                })
				.then(systemPouch.cancelReplication)
                .then(function(){
                    if (destroy){
                        return systemPouch.destroy();
                    }
                    return true;
                })
				.then(function(){
					if (remote){
                        $log.debug('Logging user out of remote...');
						return remote.logout();
					}
					return true;
				})
				.then(function(){
					$mdToast.show(
						$mdToast.simple()
							.content('See you soon, cheers!')
							.position("top right")
							.hideDelay(0)
					);
				})
				.catch(function(err){
					$log.error('Issue logging out', err);
				})
				.finally(function(){
                    $log.debug('Refreshing and sending user to login page...');
                    // full refresh so local pouches get reinitialized
                    $window.location.reload();
				});

		}

		function openSidenav(navID){
			return $mdSidenav(navID).open();
		}

		function closeSidenav(navID){
			return $mdSidenav(navID).close();
		}

		function currentTitle(){
			return $state.current.title;
		}

		function buildToggler(navID){

			var debounceFn = $mdUtil.debounce(function(){
				$mdSidenav(navID)
					.toggle()
					.then(function () {
						$log.debug("Toggle " + navID + " is done.");
					});
			}, 300);

			return debounceFn;
		}

		function exportWines(type, wineFilter){

            var filter = angular.isDefined(wineFilter) ? wineFilter : null;

			self.isExporting = true;

			MessageService.showToast("Exporting your data...");

			API.exportWines(type, filter).then(function(){
				// file should be downloaded
				MessageService.showActionToast("File downloaded. Check your download folder.");
			}).catch(function(err){
				$log.debug('Error exporting wines.', err);
				MessageService.showActionToast(err);
			}).finally(function(){
				self.isExporting = false;
			});
		}

		function search(){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/search.html',
				controller: 'SearchDialogController as dialog'
			});
		}

		function confirmLogout(event){

			$mdDialog.show({
				templateUrl: 'templates/dialogs/logout.html',
				controller: 'LogoutDialogController as dialog',
				targetEvent: event,
				clickOutsideToClose: true
			})
			.then(function(answer) {
				// this is fired for cancel too
				if (answer == 'public'){

					$analytics.eventTrack('User Logged Out', {
						"public": true
					});

					return logout(true);
				}
				if (answer == 'private'){

					$analytics.eventTrack('User Logged Out', {
						"public": false
					});

					return logout();
				}
			}, function() {
				// do nothing
			});
		}

		function launchSearch(){
			$mdDialog.show({
				templateUrl: 'templates/dialogs/search.html',
				controller: 'SearchDialogController as dialog'
			});
			closeSidenav('left');
		}
	}

})();
